const jQuery = require('jquery');

export class KendoHelpers
{

    /**
     * Helper For displaying Confirmation dialog
     * @param content 
     * @param title 
     * @param yes 
     * @param no 
     * @returns 
     */
    public static async confirm(content: string, title: string, yes: string = 'OK', no: string = 'Cancel'): Promise<boolean>
    {
        return new Promise((resolve: Function, reject: Function) => {
            const kc = jQuery('<div></div>').kendoConfirm({
                    title: title,
                    content: content,
                    messages: {
                        okText: yes,
                        cancel: no
                    }
                }).data("kendoConfirm").open();
            kc.result.done(() => {
                resolve(true);
            });
            kc.result.fail(() => {
                resolve(false);
            });
        });
    }


}